export default {
  kz: [
    {
      priority: 30,
      article: 121576,
      link: "https://www.kz.amway.com/kk/p/121576",
      name: {
        kz: "Nutrilite™ Құрамында дәрумендер, минералдар мен фитонутриенттер бар Double X, 186 таб",
        mn: "Nutrilite™ Double X Витамин, эрдэс бодис, фитонутриент бүхий Double X (31 хоногийн хэрэглээ), 186 шахмал",
        ru: "Nutrilite™ DOUBLE X™ с витаминами, минералами и фитонутриентами, 186 таб",
        kg: "Витаминдер, минералдар жана фитонутриенттер менен Double X Жаңы формула",
      },
      price: 22516,
      score: 23.35,
      image: "/images/products/121576(800х800).png",
      type: "personal_care",
    },
    {
      priority: 260,
      article: 327348,
      link: "https://www.kz.amway.com/kk/p/327348",
      name: {
        kz: "Nutrilite™ Double Energy негізгі жиынтық",
        mn: "Nutrilite™ Double Energy үндсэн багц",
        ru: "Nutrilite™ Double Energy основной набор",
        kg: "Nutrilite™ Double Energy негизги топтому",
      },
      price: 40366,
      score: 41.86,
      image: "/images/products/327348(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 270,
      article: 126136,
      link: "https://www.kz.amway.com/kk/p/126136",
      name: {
        kz: "Nutrilite™ Омега-3",
        mn: "Nutrilite™ Омега-3",
        ru: "NUTRILITE™ Омега-3 комплекс, 60 капс.",
        kg: "Nutrilite™ Омега-3 Комплекси Плюс",
      },
      price: 17850,
      score: 18.51,
      image: "/images/products/126136(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 40,
      article: 327875,
      link: "https://www.kz.amway.com/kk/p/327875",
      name: {
        kz: "Nutrilite™ Ваниль, Шоколад, Жидек дәмдерімен Mix Дене салмағын азайту және бақылау жиынтығы",
        mn: "Bundle Active Weight loss mix Vanilla Chocolate Body Guru by Nutrilite™",
        kg: "Салмакты азайтуу жана көзөмөлдөө Ваниль, Шоколад, Мөмөлөр топтому. Body Guru by Nutrilite™ программасы 10% арзандатуу менен",
        ru: "Nutrilite™ набор Body Guru Снижение и контроль веса Mix со вкусами: Ваниль, Шоколад, Ягоды",
      },
      price: 186255,
      score: 193.14,
      image: "/images/products/317528(800х800).jpg",
      type: "health",
    },
    {
      priority: 70,
      article: 327378,
      link: "https://www.kz.amway.com/kk/p/307777",
      name: {
        kz: "Nutrilite™ Ішектің сау микробиомасы жиынтығы",
        mn: "Nutrilite™ Healthy gut microbiome bundle",
        kg: "Nutrilite™ Саламаттуу ичеги микробиому топтому 5% арзандатуу менен",
        ru: "Nutrilite™ Набор Здоровый микробиом кишечника",
      },
      price: 105420,
      score: 109.32,
      image: "/images/products/307777(800х800).jpg",
      type: "health",
    },
    {
      priority: 80,
      article: 327593,
      link: "https://www.kz.amway.com/kk/p/327593",
      name: {
        kz: "Nutrilite™ Функционалдық тамақтану» күшейтілген жинағы Double X-пен Double Energy-ден",
        mn: "Nutrilite™ Double Energy-ийн Double X-тай функционал хооллолтын иж бүрдэл",
        kg: "Double Energy’ден Double X менен функционалдуу тамактануу 5% арзандатуу менен",
        ru: "Nutrilite™ Функциональное питание с Double X от Double Energy",
      },
      price: 54381,
      score: 56.39,
      image: "/images/products/303246(800х800).jpg",
      type: "health",
    },
    {
      priority: 10,
      article: 126753,
      link: "https://www.kz.amway.com/xs-muscle-multiplier-aminokislotnyj-kompleks-xs-power-drink/p/126753",
      name: {
        kz: "XS™ Muscle Multiplier Амин қышқылды кешені",
        mn: "XS™ Muscle Multiplier Essential Amino Acid Supplement",
        kg: "XS™ Muscle Multiplier Аминокислоттук комплекс",
        ru: "XS™ Muscle Multiplier Аминокислотный комплекс",
      },
      price: 23851,
      score: 24.73,
      image: "/images/products/126753(800x800).png",
      type: "health",
    },
    {
      priority: 110,
      article: 122447,
      link: "https://www.kz.amway.com/kk/p/122447",
      name: {
        kz: "Nutrilite™ Лютеин мен зеаксантин бар балаларға арналған Омега-3",
        mn: "Nutrilite™ Omega-3 Kids with Lutein & Zeaxanthin",
        kg: "Nutrilite™ Omega-3 Kids with Lutein & Zeaxanthin",
        ru: "Nutrilite™ Омега-3 для детей с лютеином и зеаксантином",
      },
      price: 13693,
      score: 14.2,
      image: "/images/products/122447(800х800).jpg",
      type: "health",
    },
    {
      priority: 120,
      article: 312790,
      link: "https://www.kz.amway.com/kk/p/312790",
      name: {
        kz: "NUTRILITE™ Meal Replacement Shake Chocolate шоколад дәмімен протеинді коктейльді әзiрлеуге арналған байытылған қоспа",
        mn: "NUTRILITE™ Meal Replacement Shake Chocolate",
        kg: "Шоколад даамы менен NUTRILITE™ Meal Replacement Shake   протеин коктейлин даярдоо үчүн байытылган аралашма",
        ru: "NUTRILITE™ Обогащенная смесь для приготовления протеинового коктейля Meal Replacement Shake Chocolate cо вкусом шоколада",
      },
      price: 25785,
      score: 26.74,
      image: "/images/products/312790(800x800).png",
      type: "health",
    },
    {
        priority: 130,
        article: 319068,
        link: "https://www.kz.amway.com/kk/p/319068",
        name: {
            kz: "Nutrilite™ «Өзіңді ләззатпен күту» жиынтығы ",
            mn: "Nutrilite™ Self-care for pleasure ",
            kg: "Nutrilite™ Ырахат тартуулаган жеке кам көрүү топтому",
            ru: "Nutrilite™ Набор Забота о себе в удовольствие",
        },
        price: 26058,
        score: 27.02,
        image: "/images/products/319068(800x800).png",
        type: "health",
    },
    {
        priority: 140,
        article: 308612,
        link: "https://www.kz.amway.com/kk/p/308612",
        name: {
            kz: "Nutrilite™ Сергектік миксі Can’t stop Won’t stop™",
            mn: "Nutrilite™ Can’t stop Won’t stop™",
            kg: "Nutrilite™ «Сергектик аралашмасы» Can’t stop Won’tstop™",
            ru: "Nutrilite™ «Микс Бодрости» Can’t stop Won’t stop™",
        },
        price: 10000,
        score: 10.37,
        image: "/images/products/308612(800x800).png",
        type: "health",
    },
    {
      priority: 30,
      article: 126807,
      link: "https://www.kz.amway.com/artistry-labs-programma-dlya-obnovleniya-omolozheniya-i-vyravnivaniya-tekstury-kozhi-nabor-s-devajsom-artistry-labs/p/126807",
      name: {
        kz: "Artistry Labs™ тері құрылымын жаңартуға, жасартуға және тегістеуге арналған бағдарлама (құрылғысы бар жиынтық)",
        mn: "ARTISTRY LABS™ Retexturizing system (bundle with device)",
        kg: "Artistry Labs Девайс камтыган топтом",
        ru: "Artistry Labs™ Программа для обновления, омоложения и выравнивания текстуры кожи (набор с девайсом)",
      },
      price: 179371,
      score: 186,
      image: "/images/products/126807(800x800).png",
      type: "beauty",
    },
    {
      priority: 160,
      article: 315362,
      link: "https://www.kz.amway.com/kk/p/315362",
      name: {
        kz: "ARTISTRY SKIN NUTRITION™ С дәрумені және гиалурон қышқылы сарысуы + Super Peptide Nutrilite™",
        mn: "Bundle Vitamin C+HA3 Daily Serum ARTISTRY Skin Nutrition™ +Super Peptide Nutrilite™",
        kg: "С витамини жана гиалурон кислотасы кошулган сыворотка +Super Peptide Nutrilite™ топтому",
        ru: "Набор ARTISTRY SKIN NUTRITION™ Cыворотка с витамином С и гиалуроновой кислотой + Super Peptide Nutrilite™",
      },
      price: 63252,
      score: 65.59,
      image: "/images/products/315362(800х800).png",
      type: "beauty",
    },
    {
      priority: 165,
      article: 119293,
      link: "https://www.kz.amway.com/kk/p/119293",
      name: {
        kz: "Super Peptide Nutrilite™",
        mn: "Super Peptide Nutrilite™",
        kg: "Super Peptide Nutrilite™",
        ru: "Super Peptide Nutrilite™",
      },
      price: 19758,
      score: 20.49,
      image: "/images/products/119293(800х800).png",
      type: "beauty",
    },
    {
      priority: 170,
      article: 303620,
      link: "https://www.kz.amway.com/kk/p/303620",
      name: {
        kz: "ARTISTRY SIGNATURE SELECT™ «Нұрланып тұрғандайсың» жинағы",
        mn: "ARTISTRY SIGNATURE SELECT™ Glowing skin face masks bundle",
        kg: "«Сен жарык чачып тургандайсың» топтому",
        ru: "ARTISTRY SIGNATURE SELECT™ Набор «Ты словно светишься»",
      },
      price: 48103,
      score: 49.88,
      image: "/images/products/303620(800х800).png",
      type: "beauty",
    },
    {
      priority: 175,
      article: 303621,
      link: "https://www.kz.amway.com/kk/p/303621",
      name: {
        kz: "Artistry Signature Select™ «Лездік лифтинг»",
        mn: "Artistry Signature Select™ Instant lifting face masks bundle",
        kg: "Artistry Signature Select™ «Ыкчам лифтинг» топтому",
        ru: "ARTISTRY SIGNATURE SELECT™ Набор «Мгновенный лифтинг»",
      },
      price: 48103,
      score: 49.88,
      image: "/images/products/303621(800х800).png",
      type: "beauty",
    },
    {
      priority: 180,
      article: 124827,
      link: "https://www.kz.amway.com/kk/p/124827",
      name: {
        kz: "ARTISTRY SKIN NUTRITION «Жаңару және серпімділік артуы»",
        mn: "ARTISTRY SKIN NUTRITION™ Renewing and lifting bundle",
        kg: "ARTISTRY SKIN NUTRITION™ «Жаңылоо жана Ийкемдүүлүктү жогорулатуу» топтому",
        ru: "ARTISTRY SKIN NUTRITION™ Набор «Обновление и Повышение упругости»",
      },
      price: 88350,
      score: 91.62,
      image: "/images/products/124827(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 190,
      article: 124713,
      link: "https://www.kz.amway.com/kk/p/124713",
      name: {
        kz: "ARTISTRY SKIN NUTRITION™ Кешкі күтімге арналған «Ылғалдандыру» жинағы",
        mn: "ARTISTRY SKIN NUTRITION™ Hydration evening routine bundle",
        kg: "ARTISTRY SKIN NUTRITION™ «Нымдандыруу» Кечки кам көрүү топтому",
        ru: "ARTISTRY SKIN NUTRITION™ Набор «Увлажнение» Вечерний уход",
      },
      price: 39165,
      score: 40.61,
      image: "/images/products/124713(800х800).png",
      type: "beauty",
    },
    {
      priority: 20,
      article: 126718,
      link: "https://www.kz.amway.com/p/126718",
      name: {
        kz: "Artistry Future Glow™ күтім жасайтын негіз Sell",
        mn: "Artistry Future Glow™ Суурь крем: нүүр будалт, арьс арчилгаа 2 in 1, Shell",
        ru: "Artistry Future Glow™ Ухаживающий тональный крем Shell",
        kg: "ARTISTRY FUTURE GLOW™ Кам көрүүчү тоналдык крем Shell",
      },
      price: 23944,
      score: 25,
      image: "/images/products/126720(800x800).png",
      type: "beauty",
    },
    {
      priority: 200,
      article: 124106,
      link: "https://www.kz.amway.com/kk/p/124106",
      name: {
        kz: "Glister™ Kөп функционалды тіс пастасы",
        mn: "Glister™ Multi-Action Toothpaste",
        kg: "Glister™ Көп функционалдуу тиш пастасы",
        ru: "Glister™ Многофункциональная зубная паста",
      },
      price: 3251,
      score: 3.37,
      image: "/images/products/124106(800х800).png",
      type: "personal_care",
    },
    {
      priority: 210,
      article: 124108,
      link: "https://www.kz.amway.com/kk/p/124108",
      name: {
        kz: "Glister™ Aуыз қуысына арналған көп функционалды ауыз шайғыш",
        mn: "Glister™ Multi-Action Oral Rinse",
        kg: "Glister™ Көп функционалдуу ооз көңдөйүн чайкагыч",
        ru: "Glister™ Многофункциональный ополаскиватель для полости рта",
      },
      price: 5916,
      score: 6.13,
      image: "/images/products/124108(800х800).png",
      type: "personal_care",
    },
    {
      priority: 220,
      article: 118107,
      link: "https://www.kz.amway.com/kk/p/118107",
      name: {
        kz: "g&h™ Душқа арналған ылғалдандырғыш гель, 400 мл",
        mn: "g&h™ Nourish Body Wash, 400 ml",
        kg: "G&H NOURISH+™ Shower gel",
        ru: "g&h™ Увлажняющий гель для душа, 400 мл",
      },
      price: 5389,
      score: 5.59,
      image: "/images/products/118107(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 230,
      article: 118117,
      link: "https://www.kz.amway.com/g-h-protect-koncentrirovannoe-zhidkoe-mylo-g-h/p/118117",
      name: {
        kz: "g&h™ Қолға арналған бактерияға қарсы сұйық сабын, 250 мл",
        mn: "g&h™ Protect Hand Soap, 250 мл",
        kg: "G&H PROTECT+™ Concentrated hand soap gel",
        ru: "g&h™ Антибактериальное жидкое мыло для рук, 250 мл",
      },
      price: 4033,
      score: 4.18,
      image: "/images/products/118117(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 250,
      article: 118120,
      link: "https://www.kz.amway.com/kk/p/118120",
      name: {
        kz: "g&h™ Шарикті дезодорант-антиперспирант",
        mn: "g&h™ Protect Antiperspirant Deodorant Roll-On",
        kg: "G&H PROTECT+™ Deodorant & anti-perspirant roll-on",
        ru: "g&h™ Шариковый дезодорант-антиперспирант",
      },
      price: 3723,
      score: 3.86,
      image: "/images/products/118120(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 290,
      article: 327942,
      link: "https://www.kz.amway.com/kk/p/327942",
      name: {
        kz: "Nutrilite™ Double Energy.Kids",
        mn: "Nutrilite™ Double Energy.Kids",
        ru: "Nutrilite™ Double Energy.Kids",
        kg: "Nutrilite™  Double Energy.Kids",
      },
      price: 37935,
      score: 39.34,
      image: "/images/products/327942(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 300,
      article: 327376,
      link: "https://www.kz.amway.com/kk/p/327376",
      name: {
        kz: "NUTRILITE™ Body Detox жиынтығы",
        mn: "NUTRILITE™ Body Detox багц",
        ru: "NUTRILITE™ Body Detox набор",
        kg: "NUTRILITE™ Body Detox топтому 5% арзандатуу менен",
      },
      price: 88417,
      score: 92,
      image: "/images/products/327376(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 310,
      article: 126738,
      link: "https://www.kz.amway.com/kk/p/126738",
      name: {
        kz: "Artistry Go Vibrant™ Қабаққа арналған төрт түсті бояу палитрасы, Berry Garden",
        mn: "Artistry Go Vibrant™ Дөрвөлсөн өнгийн зовхины тень, Berry Garden",
        ru: "Artistry Go Vibrant™ Четырехцветная палитра теней для век, Berry Garden",
        kg: "ARTISTRY EVER PERFECT™ Кабак боёкторунун төрт түстүү палитрасы Berry Garden",
      },
      price: 30481,
      score: 32,
      image: "/images/products/126738(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 320,
      article: 127473,
      link: "https://www.kz.amway.com/kk/p/127473",
      name: {
        kz: "Go Vibrant™ Кремді және құрғақ далап 2-де 1, Pink Spring Fling",
        mn: "Artistry Go Vibrant™ Тосон болон хуурай хацар өнгөлөгч 2/1, Pink Spring Fling",
        ru: "Artistry Go Vibrant™ Кремовые и сухие румяна 2в1, Pink Spring Fling",
        kg: "AARTISTRY GO VIBRANT™ Кремдүү жана кургак бет кызарткычтар 1де 2 Pink Spring Fling",
      },
      price: 17671,
      score: 18,
      image: "/images/products/127473(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 330,
      article: 126457,
      link: "https://www.kz.amway.com/kk/p/126457",
      name: {
        kz: "Satinique™ Шаштың түсуіне қарсы сусабын, 280 мл",
        mn: "Satinique™ Үс уналтын эсрэг шампунь, 280 мл",
        ru: "Satinique™ Шампунь против выпадения волос, 280 мл",
        kg: "Satinique™ Чачтын түшүшүнө каршы шампунь",
      },
      price: 5801,
      score: 6.02,
      image: "/images/products/126457(800х800).png",
      type: "beauty",
    },
    {
      priority: 340,
      article: 124746,
      link: "https://www.kz.amway.com/kk/p/124746",
      name: {
        kz: "Atmosphere Mini",
        mn: "Atmosphere Mini",
        ru: "Atmosphere Mini",
        kg: "Atmosphere Mini",
      },
      price: 378250,
      score: 393.23,
      image: "/images/products/124746(800х800).jpg",
      type: "health",
    },
    {
      priority: 350,
      article: 124112,
      link: "https://www.kz.amway.com/kk/p/124112",
      name: {
        kz: "Glister™ Kөп функционалды тіс тазалайтын жіп",
        mn: "Glister™ Многофункциональная зубная нить",
        kg: "Glister™ Көп функционалдуу тиш жиби",
        ru: "Glister™ Многофункциональная зубная нить",
      },
      price: 378250,
      score: 393.23,
      image: "/images/products/124112(800х800).jpg",
      type: "health",
    },
  ],
  kg: [
    {
      priority: 80,
      article: 327348,
      link: "https://www.kz.amway.com/kk/p/327348",
      name: {
        kz: "Nutrilite™ Double Energy негізгі жиынтық",
        mn: "Nutrilite™ Double Energy үндсэн багц",
        ru: "Nutrilite™ Double Energy основной набор",
        kg: "Nutrilite™ Double Energy негизги топтому",
      },
      price: 40366,
      score: 41.86,
      image: "/images/products/327348(800х800).jpg",
      type: "personal_care",
    },
        {
      priority: 270,
      article: 126136,
      link: "https://www.kz.amway.com/kk/p/126136",
      name: {
        kz: "Nutrilite™ Омега-3",
        mn: "Nutrilite™ Омега-3",
        ru: "NUTRILITE™ Омега-3 комплекс, 60 капс.",
        kg: "Nutrilite™ Омега-3 Комплекси Плюс",
      },
      price: 17850,
      score: 18.51,
      image: "/images/products/126136(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 280,
      article: 121576,
      link: "https://www.kz.amway.com/kk/p/121576",
      name: {
        kz: "Nutrilite™ Құрамында дәрумендер, минералдар мен фитонутриенттер бар Double X, 186 таб",
        mn: "Nutrilite™ Double X Витамин, эрдэс бодис, фитонутриент бүхий Double X (31 хоногийн хэрэглээ), 186 шахмал",
        ru: "Nutrilite™ DOUBLE X™ с витаминами, минералами и фитонутриентами, 186 таб",
        kg: "Витаминдер, минералдар жана фитонутриенттер менен Double X Жаңы формула",
      },
      price: 22516,
      score: 23.35,
      image: "/images/products/121576(800х800).png",
      type: "personal_care",
    },
    {
      priority: 40,
      article: 327875,
      link: "https://www.kz.amway.com/kk/p/327875",
      name: {
        kz: "Nutrilite™ Ваниль, Шоколад, Жидек дәмдерімен Mix Дене салмағын азайту және бақылау жиынтығы",
        mn: "Bundle Active Weight loss mix Vanilla Chocolate Body Guru by Nutrilite™",
        kg: "Салмакты азайтуу жана көзөмөлдөө Ваниль, Шоколад, Мөмөлөр топтому. Body Guru by Nutrilite™ программасы 10% арзандатуу менен",
        ru: "Nutrilite™ набор Body Guru Снижение и контроль веса Mix со вкусами: Ваниль, Шоколад, Ягоды",
      },
      price: 186255,
      score: 194.14,
      image: "/images/products/317528(800х800).jpg",
      type: "health",
    },
    {
      priority: 70,
      article: 327378,
      link: "https://www.kz.amway.com/kk/p/307777",
      name: {
        kz: "Nutrilite™ Ішектің сау микробиомасы жиынтығы",
        mn: "Nutrilite™ Healthy gut microbiome bundle",
        kg: "Nutrilite™ Саламаттуу ичеги микробиому топтому 5% арзандатуу менен",
        ru: "Nutrilite™ Набор Здоровый микробиом кишечника",
      },
      price: 105420,
      score: 109.32,
      image: "/images/products/307777(800х800).jpg",
      type: "health",
    },
    {
      priority: 80,
      article: 327593,
      link: "https://www.kz.amway.com/kk/p/327593",
      name: {
        kz: "Nutrilite™ Функционалдық тамақтану» күшейтілген жинағы Double X-пен Double Energy-ден",
        mn: "Nutrilite™ Double Energy-ийн Double X-тай функционал хооллолтын иж бүрдэл",
        kg: "Double Energy’ден Double X менен функционалдуу тамактануу 5% арзандатуу менен",
        ru: "Nutrilite™ Функциональное питание с Double X от Double Energy",
      },
      price: 54381,
      score: 56.39,
      image: "/images/products/303246(800х800).png",
      type: "health",
    },
    {
      priority: 10,
      article: 126753,
      link: "https://www.kz.amway.com/xs-muscle-multiplier-aminokislotnyj-kompleks-xs-power-drink/p/126753",
      name: {
        kz: "XS™ Muscle Multiplier Амин қышқылды кешені",
        mn: "XS™ Muscle Multiplier Essential Amino Acid Supplement",
        kg: "XS™ Muscle Multiplier Аминокислоттук комплекс",
        ru: "XS™ Muscle Multiplier Аминокислотный комплекс",
      },
      price: 23851,
      score: 24.73,
      image: "/images/products/126753(800x800).png",
      type: "health",
    },
    {
      priority: 110,
      article: 122447,
      link: "https://www.kz.amway.com/kk/p/122447",
      name: {
        kz: "Nutrilite™ Лютеин мен зеаксантин бар балаларға арналған Омега-3",
        mn: "Nutrilite™ Omega-3 Kids with Lutein & Zeaxanthin",
        kg: "Nutrilite™ Omega-3 Kids with Lutein & Zeaxanthin",
        ru: "Nutrilite™ Омега-3 для детей с лютеином и зеаксантином",
      },
      price: 13693,
      score: 14.2,
      image: "/images/products/122447(800х800).jpg",
      type: "health",
    },
    {
      priority: 120,
      article: 312790,
      link: "https://www.kz.amway.com/kk/p/312790",
      name: {
        kz: "NUTRILITE™ Meal Replacement Shake Chocolate шоколад дәмімен протеинді коктейльді әзiрлеуге арналған байытылған қоспа",
        mn: "NUTRILITE™ Meal Replacement Shake Chocolate",
        kg: "Шоколад даамы менен NUTRILITE™ Meal Replacement Shake   протеин коктейлин даярдоо үчүн байытылган аралашма",
        ru: "NUTRILITE™ Обогащенная смесь для приготовления протеинового коктейля Meal Replacement Shake Chocolate cо вкусом шоколада",
      },
      price: 25785,
      score: 26.74,
      image: "/images/products/312790(800x800).png",
      type: "health",
    },
    {
        priority: 130,
        article: 319068,
        link: "https://www.kz.amway.com/kk/p/319068",
        name: {
            kz: "Nutrilite™ «Өзіңді ләззатпен күту» жиынтығы ",
            mn: "Nutrilite™ Self-care for pleasure ",
            kg: "Nutrilite™ Ырахат тартуулаган жеке кам көрүү топтому",
            ru: "Nutrilite™ Набор Забота о себе в удовольствие",
        },
        price: 26058,
        score: 27.02,
        image: "/images/products/319068(800x800).png",
        type: "health",
    },
    {
        priority: 140,
        article: 308612,
        link: "https://www.kz.amway.com/kk/p/308612",
        name: {
            kz: "Nutrilite™ Сергектік миксі Can’t stop Won’t stop™",
            mn: "Nutrilite™ Can’t stop Won’t stop™",
            kg: "Nutrilite™ «Сергектик аралашмасы» Can’t stop Won’tstop™",
            ru: "Nutrilite™ «Микс Бодрости» Can’t stop Won’t stop™",
        },
        price: 10000,
        score: 10.37,
        image: "/images/products/308612(800x800).png",
        type: "health",
    },
    {
      priority: 30,
      article: 126807,
      link: "https://www.kz.amway.com/artistry-labs-programma-dlya-obnovleniya-omolozheniya-i-vyravnivaniya-tekstury-kozhi-nabor-s-devajsom-artistry-labs/p/126807",
      name: {
        kz: "Artistry Labs™ тері құрылымын жаңартуға, жасартуға және тегістеуге арналған бағдарлама (құрылғысы бар жиынтық)",
        mn: "ARTISTRY LABS™ Retexturizing system (bundle with device)",
        kg: "Artistry Labs Девайс камтыган топтом",
        ru: "Artistry Labs™ Программа для обновления, омоложения и выравнивания текстуры кожи (набор с девайсом)",
      },
      price: 179371,
      score: 186,
      image: "/images/products/126807(800x800).png",
      type: "beauty",
    },
    {
      priority: 160,
      article: 315362,
      link: "https://www.kz.amway.com/kk/p/315362",
      name: {
        kz: "ARTISTRY SKIN NUTRITION™ С дәрумені және гиалурон қышқылы сарысуы + Super Peptide Nutrilite™",
        mn: "Bundle Vitamin C+HA3 Daily Serum ARTISTRY Skin Nutrition™ +Super Peptide Nutrilite™",
        kg: "С витамини жана гиалурон кислотасы кошулган сыворотка +Super Peptide Nutrilite™ топтому",
        ru: "Набор ARTISTRY SKIN NUTRITION™ Cыворотка с витамином С и гиалуроновой кислотой + Super Peptide Nutrilite™",
      },
      price: 63252,
      score: 65.59,
      image: "/images/products/315362(800х800).png",
      type: "beauty",
    },
    {
      priority: 165,
      article: 119293,
      link: "https://www.kz.amway.com/kk/p/119293",
      name: {
        kz: "Super Peptide Nutrilite™",
        mn: "Super Peptide Nutrilite™",
        kg: "Super Peptide Nutrilite™",
        ru: "Super Peptide Nutrilite™",
      },
      price: 19758,
      score: 20.49,
      image: "/images/products/119293(800х800).png",
      type: "beauty",
    },
    {
      priority: 170,
      article: 303620,
      link: "https://www.kz.amway.com/kk/p/303620",
      name: {
        kz: "ARTISTRY SIGNATURE SELECT™ «Нұрланып тұрғандайсың» жинағы",
        mn: "ARTISTRY SIGNATURE SELECT™ Glowing skin face masks bundle",
        kg: "«Сен жарык чачып тургандайсың» топтому",
        ru: "ARTISTRY SIGNATURE SELECT™ Набор «Ты словно светишься»",
      },
      price: 48103,
      score: 49.88,
      image: "/images/products/303620(800х800).png",
      type: "beauty",
    },
    {
      priority: 175,
      article: 303621,
      link: "https://www.kz.amway.com/kk/p/303621",
      name: {
        kz: "Artistry Signature Select™ «Лездік лифтинг»",
        mn: "Artistry Signature Select™ Instant lifting face masks bundle",
        kg: "Artistry Signature Select™ «Ыкчам лифтинг» топтому",
        ru: "ARTISTRY SIGNATURE SELECT™ Набор «Мгновенный лифтинг»",
      },
      price: 48103,
      score: 49.88,
      image: "/images/products/303621(800х800).png",
      type: "beauty",
    },
    {
      priority: 180,
      article: 124827,
      link: "https://www.kz.amway.com/kk/p/124827",
      name: {
        kz: "ARTISTRY SKIN NUTRITION «Жаңару және серпімділік артуы»",
        mn: "ARTISTRY SKIN NUTRITION™ Renewing and lifting bundle",
        kg: "ARTISTRY SKIN NUTRITION™ «Жаңылоо жана Ийкемдүүлүктү жогорулатуу» топтому",
        ru: "ARTISTRY SKIN NUTRITION™ Набор «Обновление и Повышение упругости»",
      },
      price: 88350,
      score: 91.62,
      image: "/images/products/124827(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 190,
      article: 124713,
      link: "https://www.kz.amway.com/kk/p/124713",
      name: {
        kz: "ARTISTRY SKIN NUTRITION™ Кешкі күтімге арналған «Ылғалдандыру» жинағы",
        mn: "ARTISTRY SKIN NUTRITION™ Hydration evening routine bundle",
        kg: "ARTISTRY SKIN NUTRITION™ «Нымдандыруу» Кечки кам көрүү топтому",
        ru: "ARTISTRY SKIN NUTRITION™ Набор «Увлажнение» Вечерний уход",
      },
      price: 39165,
      score: 40.61,
      image: "/images/products/124713(800х800).png",
      type: "beauty",
    },
    {
      priority: 20,
      article: 126718,
      link: "https://www.kz.amway.com/p/126718",
      name: {
        kz: "Artistry Future Glow™ күтім жасайтын негіз Sell",
        mn: "Artistry Future Glow™ Суурь крем: нүүр будалт, арьс арчилгаа 2 in 1, Shell",
        kg: "ARTISTRY FUTURE GLOW™ Кам көрүүчү тоналдык крем Shell",
        ru: "Artistry Future Glow™ Ухаживающий тональный крем Shell",
      },
      price: 23944,
      score: 25,
      image: "/images/products/126720(800x800).png",
      type: "beauty",
    },
    {
      priority: 200,
      article: 124106,
      link: "https://www.kz.amway.com/kk/p/124106",
      name: {
        kz: "Glister™ Kөп функционалды тіс пастасы",
        mn: "Glister™ Multi-Action Toothpaste",
        kg: "Glister™ Көп функционалдуу тиш пастасы",
        ru: "Glister™ Многофункциональная зубная паста",
      },
      price: 3251,
      score: 3.37,
      image: "/images/products/124106(800х800).png",
      type: "personal_care",
    },
    {
      priority: 210,
      article: 124108,
      link: "https://www.kz.amway.com/kk/p/124108",
      name: {
        kz: "Glister™ Aуыз қуысына арналған көп функционалды ауыз шайғыш",
        mn: "Glister™ Multi-Action Oral Rinse",
        kg: "Glister™ Көп функционалдуу ооз көңдөйүн чайкагыч",
        ru: "Glister™ Многофункциональный ополаскиватель для полости рта",
      },
      price: 5916,
      score: 6.13,
      image: "/images/products/124108(800х800).png",
      type: "personal_care",
    },
    {
      priority: 220,
      article: 118107,
      link: "https://www.kz.amway.com/kk/p/118107",
      name: {
        kz: "g&h™ Душқа арналған ылғалдандырғыш гель, 400 мл",
        mn: "g&h™ Nourish Body Wash, 400 ml",
        kg: "G&H NOURISH+™ Shower gel",
        ru: "g&h™ Увлажняющий гель для душа, 400 мл",
      },
      price: 5389,
      score: 5.59,
      image: "/images/products/118107(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 230,
      article: 118117,
      link: "https://www.kz.amway.com/g-h-protect-koncentrirovannoe-zhidkoe-mylo-g-h/p/118117",
      name: {
        kz: "g&h™ Қолға арналған бактерияға қарсы сұйық сабын, 250 мл",
        mn: "g&h™ Protect Hand Soap, 250 мл",
        kg: "G&H PROTECT+™ Concentrated hand soap gel",
        ru: "g&h™ Антибактериальное жидкое мыло для рук, 250 мл",
      },
      price: 4033,
      score: 4.18,
      image: "/images/products/118117(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 250,
      article: 118120,
      link: "https://www.kz.amway.com/kk/p/118120",
      name: {
        kz: "g&h™ Шарикті дезодорант-антиперспирант",
        mn: "g&h™ Protect Antiperspirant Deodorant Roll-On",
        kg: "G&H PROTECT+™ Deodorant & anti-perspirant roll-on",
        ru: "g&h™ Шариковый дезодорант-антиперспирант",
      },
      price: 3723,
      score: 3.86,
      image: "/images/products/118120(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 290,
      article: 327942,
      link: "https://www.kz.amway.com/kk/p/327942",
      name: {
        kz: "Nutrilite™ Double Energy.Kids",
        mn: "Nutrilite™ Double Energy.Kids",
        ru: "Nutrilite™ Double Energy.Kids",
        kg: "Nutrilite™  Double Energy.Kids",
      },
      price: 37935,
      score: 39.34,
      image: "/images/products/327942(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 300,
      article: 327376,
      link: "https://www.kz.amway.com/kk/p/327376",
      name: {
        kz: "NUTRILITE™ Body Detox жиынтығы",
        mn: "NUTRILITE™ Body Detox багц",
        ru: "NUTRILITE™ Body Detox набор",
        kg: "NUTRILITE™ Body Detox топтому 5% арзандатуу менен",
      },
      price: 88417,
      score: 92,
      image: "/images/products/327376(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 310,
      article: 126738,
      link: "https://www.kz.amway.com/kk/p/126738",
      name: {
        kz: "Artistry Go Vibrant™ Қабаққа арналған төрт түсті бояу палитрасы, Berry Garden",
        mn: "Artistry Go Vibrant™ Дөрвөлсөн өнгийн зовхины тень, Berry Garden",
        ru: "Artistry Go Vibrant™ Четырехцветная палитра теней для век, Berry Garden",
        kg: "ARTISTRY EVER PERFECT™ Кабак боёкторунун төрт түстүү палитрасы Berry Garden",
      },
      price: 30481,
      score: 32,
      image: "/images/products/126738(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 320,
      article: 127473,
      link: "https://www.kz.amway.com/kk/p/127473",
      name: {
        kz: "Go Vibrant™ Кремді және құрғақ далап 2-де 1, Pink Spring Fling",
        mn: "Artistry Go Vibrant™ Тосон болон хуурай хацар өнгөлөгч 2/1, Pink Spring Fling",
        ru: "Artistry Go Vibrant™ Кремовые и сухие румяна 2в1, Pink Spring Fling",
        kg: "AARTISTRY GO VIBRANT™ Кремдүү жана кургак бет кызарткычтар 1де 2 Pink Spring Fling",
      },
      price: 17671,
      score: 18,
      image: "/images/products/127473(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 330,
      article: 126457,
      link: "https://www.kz.amway.com/kk/p/126457",
      name: {
        kz: "Satinique™ Шаштың түсуіне қарсы сусабын, 280 мл",
        mn: "Satinique™ Үс уналтын эсрэг шампунь, 280 мл",
        ru: "Satinique™ Шампунь против выпадения волос, 280 мл",
        kg: "Satinique™ Чачтын түшүшүнө каршы шампунь",
      },
      price: 5801,
      score: 6.02,
      image: "/images/products/126457(800х800).png",
      type: "beauty",
    },
    {
      priority: 340,
      article: 124746,
      link: "https://www.kz.amway.com/kk/p/124746",
      name: {
        kz: "Atmosphere Mini",
        mn: "Atmosphere Mini",
        ru: "Atmosphere Mini",
        kg: "Atmosphere Mini",
      },
      price: 378250,
      score: 393.23,
      image: "/images/products/124746(800х800).jpg",
      type: "health",
    },
    {
      priority: 350,
      article: 124112,
      link: "https://www.kz.amway.com/kk/p/124112",
      name: {
        kz: "Glister™ Kөп функционалды тіс тазалайтын жіп",
        mn: "Glister™ Многофункциональная зубная нить",
        kg: "Glister™ Көп функционалдуу тиш жиби",
        ru: "Glister™ Многофункциональная зубная нить",
      },
      price: 378250,
      score: 393.23,
      image: "/images/products/124112(800х800).jpg",
      type: "health",
    },
  ],
  mn: [
    {
      priority: 10,
      article: 121576,
      link: "https://www.kz.amway.com/kk/p/121576",
      name: {
        kz: "Nutrilite™ Құрамында дәрумендер, минералдар мен фитонутриенттер бар Double X, 186 таб",
        mn: "Nutrilite™ Double X Витамин, эрдэс бодис, фитонутриент бүхий Double X (31 хоногийн хэрэглээ), 186 шахмал",
        kg: "Витаминдер, минералдар жана фитонутриенттер менен Double X Жаңы формула",
        ru: "Nutrilite™ DOUBLE X™ с витаминами, минералами и фитонутриентами, 186 таб",
      },
      price: 25811.2308,
      score: 23.35,
      image: "/images/products/121576(800х800).png",
      type: "personal_care",
    },
    {
      priority: 20,
      article: 126136,
      link: "https://www.kz.amway.com/kk/p/126136",
      name: {
        kz: "Nutrilite™ Омега-3",
        mn: "Nutrilite™ Омега-3",
        ru: "NUTRILITE™ Омега-3 комплекс, 60 капс.",
        kg: "Nutrilite™ Омега-3 Комплекси Плюс",
      },
      price: 19332.9231,
      score: 18.55,
      image: "/images/products/126136(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 30,
      article: 327351,
      link: "https://www.kz.amway.com/kk/p/327351",
      name: {
        kz: "Nutrilite™ Double Energy негізгі жиынтық",
        mn: "Nutrilite™ Double Energy үндсэн багц",
        ru: "Nutrilite™ Double Energy основной набор",
        kg: "Nutrilite™ Double Energy негизги топтому",
      },
      price: 45144.1539,
      score: 43.31,
      image: "/images/products/327348(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 40,
      article: 327875,
      link: "https://www.kz.amway.com/kk/p/327875",
      name: {
        kz: "Nutrilite™ Ваниль, Шоколад, Жидек дәмдерімен Mix Дене салмағын азайту және бақылау жиынтығы",
        mn: "Bundle Active Weight loss mix Vanilla Chocolate Body Guru by Nutrilite™",
        kg: "Салмакты азайтуу жана көзөмөлдөө Ваниль, Шоколад, Мөмөлөр топтому. Body Guru by Nutrilite™ программасы 10% арзандатуу менен",
        ru: "Nutrilite™ набор Body Guru Снижение и контроль веса Mix со вкусами: Ваниль, Шоколад, Ягоды",
      },
      price: 209281.077,
      score: 200.77,
      image: "/images/products/317528(800х800).jpg",
      type: "health",
    },
    {
      priority: 70,
      article: 327378,
      link: "https://www.kz.amway.com/kk/p/307777",
      name: {
        kz: "Nutrilite™ Ішектің сау микробиомасы жиынтығы",
        mn: "Nutrilite™ Healthy gut microbiome bundle",
        kg: "Nutrilite™ Саламаттуу ичеги микробиому топтому 5% арзандатуу менен",
        ru: "Nutrilite™ Набор Здоровый микробиом кишечника",
      },
      price: 118696.9231,
      score: 113.87,
      image: "/images/products/307777(800х800).jpg",
      type: "health",
    },
    {
      priority: 80,
      article: 327593,
      link: "https://www.kz.amway.com/kk/p/327593",
      name: {
        kz: "Nutrilite™ Функционалдық тамақтану» күшейтілген жинағы Double X-пен Double Energy-ден",
        mn: "Nutrilite™ Double Energy-ийн Double X-тай функционал хооллолтын иж бүрдэл",
        kg: "Double Energy’ден Double X менен функционалдуу тамактануу 5% арзандатуу менен",
        ru: "Nutrilite™ Функциональное питание с Double X от Double Energy",
      },
      price: 61262,
      score: 58.77,
      image: "/images/products/303246(800х800).jpg",
      type: "health",
    },
    {
      priority: 90,
      article: 126753,
      link: "https://www.kz.amway.com/xs-muscle-multiplier-aminokislotnyj-kompleks-xs-power-drink/p/126753",
      name: {
        kz: "XS™ Muscle Multiplier Амин қышқылды кешені",
        mn: "XS™ Muscle Multiplier Essential Amino Acid Supplement",
        kg: "XS™ Muscle Multiplier Аминокислоттук комплекс",
        ru: "XS™ Muscle Multiplier Аминокислотный комплекс",
      },
      price: 26325.8462,
      score: 25.25,
      image: "/images/products/126753(800x800).png",
      type: "health",
    },
    {
      priority: 110,
      article: 122447,
      link: "https://www.kz.amway.com/kk/p/122447",
      name: {
        kz: "Nutrilite™ Лютеин мен зеаксантин бар балаларға арналған Омега-3",
        mn: "Nutrilite™ Omega-3 Kids with Lutein & Zeaxanthin",
        kg: "Nutrilite™ Omega-3 Kids with Lutein & Zeaxanthin",
        ru: "Nutrilite™ Омега-3 для детей с лютеином и зеаксантином",
      },
      price: 16174.7693,
      score: 15.52,
      image: "/images/products/122447(800х800).jpg",
      type: "health",
    },
    {
      priority: 120,
      article: 312790,
      link: "https://www.kz.amway.com/kk/p/312790",
      name: {
        kz: "NUTRILITE™ Meal Replacement Shake Chocolate шоколад дәмімен протеинді коктейльді әзiрлеуге арналған байытылған қоспа",
        mn: "NUTRILITE™ Meal Replacement Shake Chocolate",
        kg: "Шоколад даамы менен NUTRILITE™ Meal Replacement Shake   протеин коктейлин даярдоо үчүн байытылган аралашма",
        ru: "NUTRILITE™ Обогащенная смесь для приготовления протеинового коктейля Meal Replacement Shake Chocolate cо вкусом шоколада",
      },
      price: 28990.1539,
      score: 27.81,
      image: "/images/products/312790(800x800).png",
      type: "health",
    },
    {
        priority: 130,
        article: 319068,
        link: "https://www.kz.amway.com/kk/p/319068",
        name: {
            kz: "Nutrilite™ «Өзіңді ләззатпен күту» жиынтығы ",
            mn: "Nutrilite™ Self-care for pleasure ",
            kg: "Nutrilite™ Ырахат тартуулаган жеке кам көрүү топтому",
            ru: "Nutrilite™ Набор Забота о себе в удовольствие",
        },
        price: 29100.4616,
        score: 27.92,
        image: "/images/products/319068(800x800).png",
        type: "health",
    },
    {
        priority: 140,
        article: 308612,
        link: "https://www.kz.amway.com/kk/p/308612",
        name: {
            kz: "Nutrilite™ Сергектік миксі Can’t stop Won’t stop™",
            mn: "Nutrilite™ Can’t stop Won’t stop™",
            kg: "Nutrilite™ «Сергектик аралашмасы» Can’t stop Won’tstop™",
            ru: "Nutrilite™ «Микс Бодрости» Can’t stop Won’t stop™",
        },
        price: 11140.9231,
        score: 10.69,
        image: "/images/products/308612(800x800).png",
        type: "health",
    },
    {
      priority: 30,
      article: 126807,
      link: "https://www.kz.amway.com/artistry-labs-programma-dlya-obnovleniya-omolozheniya-i-vyravnivaniya-tekstury-kozhi-nabor-s-devajsom-artistry-labs/p/126807",
      name: {
        kz: "Artistry Labs™ тері құрылымын жаңартуға, жасартуға және тегістеуге арналған бағдарлама (құрылғысы бар жиынтық)",
        mn: "ARTISTRY LABS™ Retexturizing system (bundle with device)",
        kg: "Artistry Labs Девайс камтыган топтом",
        ru: "Artistry Labs™ Программа для обновления, омоложения и выравнивания текстуры кожи (набор с девайсом)",
      },
      price: 203911.077,
      score: 196,
      image: "/images/products/126807(800x800).png",
      type: "beauty",
    },
    {
      priority: 160,
      article: 315362,
      link: "https://www.kz.amway.com/kk/p/315362",
      name: {
        kz: "ARTISTRY SKIN NUTRITION™ С дәрумені және гиалурон қышқылы сарысуы + Super Peptide Nutrilite™",
        mn: "Bundle Vitamin C+HA3 Daily Serum ARTISTRY Skin Nutrition™ +Super Peptide Nutrilite™",
        kg: "С витамини жана гиалурон кислотасы кошулган сыворотка +Super Peptide Nutrilite™ топтому",
        ru: "Набор ARTISTRY SKIN NUTRITION™ Cыворотка с витамином С и гиалуроновой кислотой + Super Peptide Nutrilite™",
      },
      price: 70692.3077,
      score: 67.82,
      image: "/images/products/315362(800х800).png",
      type: "beauty",
    },
    {
      priority: 165,
      article: 119293,
      link: "https://www.kz.amway.com/kk/p/119293",
      name: {
        kz: "Super Peptide Nutrilite™",
        mn: "Super Peptide Nutrilite™",
        kg: "Super Peptide Nutrilite™",
        ru: "Super Peptide Nutrilite™",
      },
      price: 22000.6154,
      score: 21.11,
      image: "/images/products/119293(800х800).png",
      type: "beauty",
    },
    {
      priority: 170,
      article: 303620,
      link: "https://www.kz.amway.com/kk/p/303620",
      name: {
        kz: "ARTISTRY SIGNATURE SELECT™ «Нұрланып тұрғандайсың» жинағы",
        mn: "ARTISTRY SIGNATURE SELECT™ Glowing skin face masks bundle",
        kg: "«Сен жарык чачып тургандайсың» топтому",
        ru: "ARTISTRY SIGNATURE SELECT™ Набор «Ты словно светишься»",
      },
      price: 52589.077,
      score: 50.45,
      image: "/images/products/303620(800х800).png",
      type: "beauty",
    },
    {
      priority: 175,
      article: 303621,
      link: "https://www.kz.amway.com/kk/p/303621",
      name: {
        kz: "Artistry Signature Select™ «Лездік лифтинг»",
        mn: "Artistry Signature Select™ Instant lifting face masks bundle",
        kg: "Artistry Signature Select™ «Ыкчам лифтинг» топтому",
        ru: "ARTISTRY SIGNATURE SELECT™ Набор «Мгновенный лифтинг»",
      },
      price: 52589.077,
      score: 50.45,
      image: "/images/products/303621(800х800).png",
      type: "beauty",
    },
    {
      priority: 180,
      article: 124827,
      link: "https://www.kz.amway.com/kk/p/124827",
      name: {
        kz: "ARTISTRY SKIN NUTRITION «Жаңару және серпімділік артуы»",
        mn: "ARTISTRY SKIN NUTRITION™ Renewing and lifting bundle",
        kg: "ARTISTRY SKIN NUTRITION™ «Жаңылоо жана Ийкемдүүлүктү жогорулатуу» топтому",
        ru: "ARTISTRY SKIN NUTRITION™ Набор «Обновление и Повышение упругости»",
      },
      price: 99356.4616,
      score: 95.31,
      image: "/images/products/124827(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 190,
      article: 124713,
      link: "https://www.kz.amway.com/kk/p/124713",
      name: {
        kz: "ARTISTRY SKIN NUTRITION™ Кешкі күтімге арналған «Ылғалдандыру» жинағы",
        mn: "ARTISTRY SKIN NUTRITION™ Hydration evening routine bundle",
        kg: "ARTISTRY SKIN NUTRITION™ «Нымдандыруу» Кечки кам көрүү топтому",
        ru: "ARTISTRY SKIN NUTRITION™ Набор «Увлажнение» Вечерний уход",
      },
      price: 44016.4616,
      score: 42.23,
      image: "/images/products/124713(800х800).png",
      type: "beauty",
    },
    {
      priority: 20,
      article: 126718,
      link: "https://www.kz.amway.com/p/126718",
      name: {
        kz: "Artistry Future Glow™ күтім жасайтын негіз Sell",
        mn: "Artistry Future Glow™ Суурь крем: нүүр будалт, арьс арчилгаа 2 in 1, Shell",
        ru: "Artistry Future Glow™ Ухаживающий тональный крем Shell",
        kg: "ARTISTRY FUTURE GLOW™ Кам көрүүчү тоналдык крем Shell",
      },
      price: 26406.1539,
      score: 25,
      image: "/images/products/126720(800x800).png",
      type: "beauty",
    },
    {
      priority: 200,
      article: 124106,
      link: "https://www.kz.amway.com/kk/p/124106",
      name: {
        kz: "Glister™ Kөп функционалды тіс пастасы",
        mn: "Glister™ Multi-Action Toothpaste",
        kg: "Glister™ Көп функционалдуу тиш пастасы",
        ru: "Glister™ Многофункциональная зубная паста",
      },
      price: 3728.1539,
      score: 3.58,
      image: "/images/products/124106(800х800).png",
      type: "personal_care",
    },
    {
      priority: 210,
      article: 124108,
      link: "https://www.kz.amway.com/kk/p/124108",
      name: {
        kz: "Glister™ Aуыз қуысына арналған көп функционалды ауыз шайғыш",
        mn: "Glister™ Multi-Action Oral Rinse",
        kg: "Glister™ Көп функционалдуу ооз көңдөйүн чайкагыч",
        ru: "Glister™ Многофункциональный ополаскиватель для полости рта",
      },
      price: 6983.077,
      score: 6.7,
      image: "/images/products/124108(800х800).png",
      type: "personal_care",
    },
    {
      priority: 220,
      article: 118107,
      link: "https://www.kz.amway.com/kk/p/118107",
      name: {
        kz: "g&h™ Душқа арналған ылғалдандырғыш гель, 400 мл",
        mn: "g&h™ Nourish Body Wash, 400 ml",
        kg: "G&H NOURISH+™ Shower gel",
        ru: "g&h™ Увлажняющий гель для душа, 400 мл",
      },
      price: 6177.5385,
      score: 5.93,
      image: "/images/products/118107(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 230,
      article: 118117,
      link: "https://www.kz.amway.com/g-h-protect-koncentrirovannoe-zhidkoe-mylo-g-h/p/118117",
      name: {
        kz: "g&h™ Қолға арналған бактерияға қарсы сұйық сабын, 250 мл",
        mn: "g&h™ Protect Hand Soap, 250 мл",
        kg: "G&H PROTECT+™ Concentrated hand soap gel",
        ru: "g&h™ Антибактериальное жидкое мыло для рук, 250 мл",
      },
      price: 4759.3847,
      score: 4.57,
      image: "/images/products/118117(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 250,
      article: 118120,
      link: "https://www.kz.amway.com/kk/p/118120",
      name: {
        kz: "g&h™ Шарикті дезодорант-антиперспирант",
        mn: "g&h™ Protect Antiperspirant Deodorant Roll-On",
        kg: "G&H PROTECT+™ Deodorant & anti-perspirant roll-on",
        ru: "g&h™ Шариковый дезодорант-антиперспирант",
      },
      price: 4269.5385,
      score: 4.1,
      image: "/images/products/118120(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 290,
      article: 327942,
      link: "https://www.kz.amway.com/kk/p/327942",
      name: {
        kz: "Nutrilite™ Double Energy.Kids",
        mn: "Nutrilite™ Double Energy.Kids",
        ru: "Nutrilite™ Double Energy.Kids",
        kg: "Nutrilite™ Double Energy.Kids",
      },
      price: 43871.6924,
      score: 42.09,
      image: "/images/products/327942(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 300,
      article: 327376,
      link: "https://www.kz.amway.com/kk/p/327376",
      name: {
        kz: "NUTRILITE™ Body Detox жиынтығы",
        mn: "NUTRILITE™ Body Detox багц",
        ru: "NUTRILITE™ Body Detox набор",
        kg: "NUTRILITE™ Body Detox топтому 5% арзандатуу менен",
      },
      price: 99343.077,
      score: 95,
      image: "/images/products/327376(800х800).jpg",
      type: "personal_care",
    },
    {
      priority: 310,
      article: 126738,
      link: "https://www.kz.amway.com/kk/p/126738",
      name: {
        kz: "Artistry Go Vibrant™ Қабаққа арналған төрт түсті бояу палитрасы, Berry Garden",
        mn: "Artistry Go Vibrant™ Дөрвөлсөн өнгийн зовхины тень, Berry Garden",
        ru: "Artistry Go Vibrant™ Четырехцветная палитра теней для век, Berry Garden",
        kg: "ARTISTRY EVER PERFECT™ Кабак боёкторунун төрт түстүү палитрасы Berry Garden",
      },
      price: 33647.5384,
      score: 32,
      image: "/images/products/126738(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 320,
      article: 127473,
      link: "https://www.kz.amway.com/kk/p/127473",
      name: {
        kz: "Go Vibrant™ Кремді және құрғақ далап 2-де 1, Pink Spring Fling",
        mn: "Artistry Go Vibrant™ Тосон болон хуурай хацар өнгөлөгч 2/1, Pink Spring Fling",
        ru: "Artistry Go Vibrant™ Кремовые и сухие румяна 2в1, Pink Spring Fling",
        kg: "AARTISTRY GO VIBRANT™ Кремдүү жана кургак бет кызарткычтар 1де 2 Pink Spring Fling",
      },
      price: 19502.3077,
      score: 19,
      image: "/images/products/127473(800х800).jpg",
      type: "beauty",
    },
    {
      priority: 330,
      article: 126457,
      link: "https://www.kz.amway.com/kk/p/126457",
      name: {
        kz: "Satinique™ Шаштың түсуіне қарсы сусабын, 280 мл",
        mn: "Satinique™ Үс уналтын эсрэг шампунь, 280 мл",
        ru: "Satinique™ Шампунь против выпадения волос, 280 мл",
        kg: "Satinique™ Чачтын түшүшүнө каршы шампунь",
      },
      price: 6403.6924,
      score: 6.14,
      image: "/images/products/126457(800х800).png",
      type: "beauty",
    },
    {
      priority: 340,
      article: 124746,
      link: "https://www.kz.amway.com/kk/p/124746",
      name: {
        kz: "Atmosphere Mini",
        mn: "Atmosphere Mini",
        ru: "Atmosphere Mini",
        kg: "Atmosphere Mini",
      },
      price: 418880,
      score: 401.84,
      image: "/images/products/124746(800х800).jpg",
      type: "health",
    },
    {
      priority: 350,
      article: 124112,
      link: "https://www.kz.amway.com/kk/p/124112",
      name: {
        kz: "Glister™ Kөп функционалды тіс тазалайтын жіп",
        mn: "Glister™ Многофункциональная зубная нить",
        kg: "Glister™ Көп функционалдуу тиш жиби",
        ru: "Glister™ Многофункциональная зубная нить",
      },
      price: 5568.7693,
      score: 5.34,
      image: "/images/products/124112(800х800).jpg",
      type: "health",
    },
  ],
}


